import { render, staticRenderFns } from "./BlocksDispatcher.vue?vue&type=template&id=4fdace17&"
import script from "./BlocksDispatcher.vue?vue&type=script&lang=ts&"
export * from "./BlocksDispatcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports